import dynamic from 'next/dynamic';

import type { PersonalisedBanner } from '../components/PersonalisedBanner';

import { useIsLoggedIn } from '@zoopla/user';
import { Homepage, HomepageProps } from './Homepage';

const DynamicPersonalisedBanner = dynamic(
    () =>
        import('../components/PersonalisedBanner').then(
            (module) => module.PersonalisedBanner
        ),
    { ssr: false }
) as typeof PersonalisedBanner;

export const LoggedOutHomepage = (props: Omit<HomepageProps, 'isLoggedIn'>) => {
    const isLoggedIn = useIsLoggedIn();

    return (
        <Homepage
            personalisedBanner={<DynamicPersonalisedBanner />}
            isLoggedIn={isLoggedIn}
            {...props}
        />
    );
};
